import { Icon, Text } from 'styles/AppStyles';
import { Container, Box, Button } from './Styles';
import reconnect from 'assets/svg/reconnect.svg';
import { useApp } from 'context/AppContext';
import AppService from 'services/app.service';
import { getTokenCode } from 'utils/auth';

const LoginSessionExpired = () => {
  const { state, closeModal } = useApp();

  const reLogin = async () => {
    const tokenCode = getTokenCode();
    const loginParams = tokenCode ? { ton: tokenCode } : { fbUser: state.user };

    const loginData = await AppService.storeUserLogin(loginParams);

    if (!loginData || loginData.sts !== 's') {
      console.log('Login failed');
    }
    closeModal();
    location.reload();
  };

  return (
    <Container>
      <Box>
        <Text $weight={600}>One of two things happend:</Text>
        <Text>1. Too much time has passed since your last login.</Text>
        <Text>2. You are logged in somewhere else.</Text>
      </Box>
      <Box>
        <Text $weight={600}>You can not be logged in to the game and the store at the same time</Text>
        <Text>Please re-login to the store.</Text>
      </Box>
      <Button onClick={reLogin}>
        Reconnect <Icon src={reconnect} width={13} />
      </Button>
    </Container>
  );
};

export default LoginSessionExpired;
